import styled from 'styled-components';

export const FixedText = styled.span`
  color: ${({ theme }) => theme.baseBlue.a10};
`;

export const HeaderInputContainer = styled.div<{ $isSelected?: boolean; $error?: string }>`
  width: 100%;
  font-size: 25px;
  padding: 10px;
  border-bottom: 2px solid ${({ theme, $error }) => ($error ? theme.red.a10 : theme.baseBlue.a4)};
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  &::before {
    content: '';
    width: ${({ $isSelected, $error }) => ($isSelected && !$error ? '100%' : '0')};
    height: 2px;
    background-color: ${({ theme }) => theme.baseBlue.a10};
    position: absolute;
    bottom: -2px;
    left: 0;
    transition: width 400ms ease-in-out;
  }
  svg {
    color: ${({ theme }) => theme.red.a10};
  }
`;

export const InputField = styled.input<{ $hasValue: boolean }>`
  flex-grow: 1;
  background-color: transparent;
  color: ${({ $hasValue, theme }) => ($hasValue ? theme.baseBlue.a10 : 'inherit')};
  &:focus {
    outline: none;
  }
`;

export const InputSection = styled.div``;

export const ErrorMessage = styled.span`
  font-style: italic;
  position: absolute;
  color: ${({ theme }) => theme.red.a10};
  margin-top: 5px;
  margin-left: 10px;
  font-size: 12px;
  line-height: 15px;
`;
